export const TRANSACTION_PHASES = [
  {
    id: "structuring",
    label: "Structuration",
    statuses: ["STRUCTURING", "LEGAL_REVIEW"]
  },
  {
    id: "signature",
    label: "Signature",
    statuses: ["WAITING_SIGNATURE"]
  },
  {
    id: "fundraising",
    label: "Collecte",
    statuses: ["FUNDRAISING", "READY_TO_FUND"]
  },
  {
    id: "funded",
    label: "Financement",
    statuses: ["FUNDED"]
  },
  {
    id: "active",
    label: "Exploitation",
    statuses: ["ACTIVE", "REFINANCING", "EXIT_PREPARATION"]
  },
  {
    id: "completed",
    label: "Clôture",
    statuses: ["COMPLETED"]
  }
];

export const EXCEPTIONAL_STATUSES = [
  "CANCELLED",
  "DEFAULTED"
];
